"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

function setupI18next(_ref) {
  var _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug,
      _ref$defaultNS = _ref.defaultNS,
      defaultNS = _ref$defaultNS === void 0 ? 'messages' : _ref$defaultNS,
      fallbackLng = _ref.fallbackLng,
      otherOptions = (0, _objectWithoutProperties2["default"])(_ref, ["debug", "defaultNS", "fallbackLng"]);
  var initOptions = Object.assign({
    debug: debug,
    defaultNS: defaultNS,
    fallbackLng: fallbackLng,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  }, otherOptions);

  _i18next["default"] // pass the i18n instance to react-i18next.
  .use(_reactI18next.initReactI18next) // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init(initOptions);

  return _i18next["default"];
}

var _default = setupI18next;
exports["default"] = _default;